import {
    slideUp,
    slideDown,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', (event) => {
    const accordionSections = document.querySelectorAll('.comparison-table-section');
    accordionSections.forEach(section => {
        const tabRepet = section.querySelectorAll('.cts-accordion-item');

        tabRepet.forEach(tabRepetEle => {
            const title = tabRepetEle.querySelector('.cts-accordion-title');
            const content = tabRepetEle.querySelector('.cts-accordion-content');

            if (content) {
                title.addEventListener('click', function() {
                    const isOpen = tabRepetEle.classList.contains('is-open');

                    // Toggle current
                    if (isOpen) {
                        tabRepetEle.classList.remove('is-open');
                        slideUp(content);
                    } else {
                        tabRepetEle.classList.add('is-open');
                        slideDown(content);
                    }
                });
            }
        });
    });
});